import * as actionTypes from "./actionTypes";
import * as types from "./types";

// GET Access Controls

export const fetchAccessControlRequest = (): types.FetchAccessControlRequest => ({
    type: actionTypes.FETCH_ACCESSCONTROL_REQUEST,
});

export const fetchAccessControlSuccess = (payload: types.IFetchAccessControlSuccessPayload): types.FetchAccessControlSuccess => ({
    type: actionTypes.FETCH_ACCESSCONTROL_SUCCESS,
    payload,
});

export const fetchAccessControlFailure = (payload: types.IFetchAccessControlFailurePayload): types.FetchAccessControlFailure => ({
    type: actionTypes.FETCH_ACCESSCONTROL_FAILURE,
    payload,
});


// POST Data Source 

export const postDataSourceRequest = (
    payload: types.IDataSourcePostReq
): types.PostDataSourceRequest => ({
    type: actionTypes.POST_DATASOURCE_REQUEST,
    payload
});

export const postDataSourceSuccess = (
    payload: types.IPostDataSourceSuccessPayload
): types.PostDataSourceSuccess => ({
    type: actionTypes.POST_DATASOURCE_SUCCESS,
    payload,
});

export const postDataSourceFailure = (
    payload: types.IPostDataSourceFailurePayload
): types.PostDataSourceFailure => ({
    type: actionTypes.POST_DATASOURCE_FAILURE,
    payload,
});


// PUT data source

export const putDataSourceRequest = (
    sourceId: number,
    payload: types.IDataSourcePutReq
): types.PutDataSourceRequest => ({
    type: actionTypes.PUT_DATASOURCE_REQUEST,
    sourceId,
    payload
});

export const putDataSourceSuccess = (
    payload: types.IPutDataSourceSuccessPayload
): types.PutDataSourceSuccess => ({
    type: actionTypes.PUT_DATASOURCE_SUCCESS,
    payload,
});

export const putDataSourceFailure = (
    payload: types.IPutDataSourceFailurePayload
): types.PutDataSourceFailure => ({
    type: actionTypes.PUT_DATASOURCE_FAILURE,
    payload,
});


// Sources actions
// GET all data sources

export const fetchSourcesReq = (params: types.ISearchParam): types.FetchSourcesReq => ({
    type: actionTypes.FETCH_SOURCES_LIST_REQUEST,
    params,
});

export const fetchSourcesSuccess = (
    payload: types.FetchSourcesSuccessPayload
): types.FetchSourcesSuccess => ({
    type: actionTypes.FETCH_SOURCES_LIST_SUCCESS,
    payload,
});

export const fetchSourcesFailure = (
    payload: types.FetchSourcesFailurePayload
): types.FetchSourcesFailure => ({
    type: actionTypes.FETCH_SOURCES_LIST_FAILURE,
    payload,
});


// GET data source

export const fetchSourceDetailsReq = (params: number): types.FetchSourceReq => ({
    type: actionTypes.FETCH_SOURCE_REQUEST,
    params,
});

export const fetchSourceDetailsSuccess = (
    payload: types.FetchSourceSuccessPayload
): types.FetchSourceSuccess => ({
    type: actionTypes.FETCH_SOURCE_SUCCESS,
    payload,
});

export const fetchSourceDetailsFailure = (
    payload: types.FetchSourceFailurePayload
): types.FetchSourceFailure => ({
    type: actionTypes.FETCH_SOURCE_FAILURE,
    payload,
});


// DELETE data source

export const deleteSourceReq = (
    params: number
): types.DeleteDataSourceRequest => ({
    type: actionTypes.DELETE_SOURCE_REQUEST,
    params,
});

export const deleteSourceSuccess = (
    success: types.IDeleteDataSourceSuccess
): types.DeleteDataSourceSuccess => ({
    type: actionTypes.DELETE_SOURCE_SUCCESS,
    success,
});

export const deleteSourceFailure = (
    payload: types.IDeleteDataSourceFailurePayload
): types.DeleteDataSourceFailure => ({
    type: actionTypes.DELETE_SOURCE_FAILURE,
    payload,
});


// POST Test Connection

export const postConnectionRequest = (
    payload: types.IConnectionPostReq
): types.PostConnectionRequest => ({
    type: actionTypes.POST_CONNECTION_REQUEST,
    payload
});

export const postConnectionReset = () => ({
    type: actionTypes.POST_CONNECTION_RESET,
});

export const postConnectionSuccess = (
    payload: types.IPostConnectionSuccessPayload
): types.PostConnectionSuccess => ({
    type: actionTypes.POST_CONNECTION_SUCCESS,
    payload,
});

export const postConnectionFailure = (
    payload: types.IPostConnectionFailurePayload
): types.PostConnectionFailure => ({
    type: actionTypes.POST_CONNECTION_FAILURE,
    payload,
});

// GET User: Data Stewards

export const fetchStewardRequest = (params: string): types.IFetchStewardRequest => ({
    type: actionTypes.FETCH_STEWARD_REQUEST,
    params: params
});

export const fetchStewardSuccess = (payload: types.IFetchStewardSuccessPayload): types.FetchStewardSuccess => ({
    type: actionTypes.FETCH_STEWARD_SUCCESS,
    payload
});

export const fetchStewardFailure = (payload: types.IFetchStewardFailurePayload): types.FetchStewardFailure => ({
    type: actionTypes.FETCH_STEWARD_FAILURE,
    payload
});


